export const Config = {
  // apiUrl: "http://127.0.0.1:8000/api/"
  //apiUrl: "http://ec2-52-66-252-92.ap-south-1.compute.amazonaws.com/api/"
  apiUrl: "https://adtest-trial.co.in/api/"
};


// WEBPACK FOOTER //
// ./src/shared/config.js